import {
  LiteRouter,
  Login,
  WSG,
  FreyaMicroFrontendFramework,
  Tracker,
  POSITION,
  PAGE,
  URL,
} from '@/utils'
import { setStore } from '@/store/store-standard'
import libs from '@/assets/external-libs/outside'
import MainLoading from '@/components/main-loading'
import useI18n from '@/i18n/landing'
import './index.styl'
import { httpList, List } from '../protocol/http'
import { httpHomeIndex } from './http'
import raven from '@/utils/raven-shim'
import Omega from 'Omega'
import pageTemplate from './template'
import { onDelegate } from '@/utils/action-lib'
import {
  validatePhoneNumber,
  isFitRequirementCode,
} from '@/utils/validate'
import { debounce } from 'lodash'

interface LoginData {
  ticket: string
  [key: string]: string
}

const $i18n = useI18n()
/**
 * 运行freya kyc
 */
export const $framework = new FreyaMicroFrontendFramework(
  libs
)

/**
 * @note no-this
 */
const Index = {
  template: pageTemplate,
  methods: {
    /**
     * 该校验仅用于埋点时使用，登录的校验已移交给passport
     */
    validate(value = '') {
      value = value.trim()
      if (value === '') {
        return [false]
      }
      if (!validatePhoneNumber(value)) {
        return [false]
      }
      if (!isFitRequirementCode(value)) {
        return [false]
      }
      return [true]
    },
    // 简易toast
    toast(msg = '') {
      if (Index.$data.isToasting) {
        return
      }
      Index.$data.isToasting = true
      const el = document.createElement('div')
      el.innerHTML = `<div class="login-toast"><span class="icon remind"></span><span class="text">${msg}</span></div>`
      el.className = 'login-toast-wrapper'
      document.body.appendChild(el)
      setTimeout(() => {
        document.body.removeChild(el)
        Index.$data.isToasting = false
      }, 3000)
    },
    /**
     * 二期实验
     * 1. kyc流程中的下载入口，apollo配置开关优先级 > 实验下发
     */
    storeAbState(ajaxData: {
      freya_landing_418506?: {
        params?: { [key: string]: number }
      }
    }) {
      const subSwitcher =
        window.__INIT_STATE__.switcher.kycDownload
      try {
        // 开启实验开关
        if (window.__INIT_STATE__.switcher.ab) {
          // 命中实验
          if (ajaxData?.freya_landing_418506?.params) {
            // 实验暂未线下，强制展示下载入口开关
            if (subSwitcher) {
              ajaxData.freya_landing_418506.params.download = 1
            }
            // 以实验配置为准
            return setStore(
              'ab',
              ajaxData.freya_landing_418506.params
            )
          }
        }
      } catch (e: any) {
        Tracker.trackWithRaven('FN:storeAbState', {
          e: e.toString(),
        })
      }
      // 兜底默认
      setStore('ab', {
        download: subSwitcher ? 1 : 0,
        flow: 0,
      })
    },
    setLoading(value: boolean) {
      Index.$data.isLoading = value
      if (value) {
        $('.next-btn').addClass('is-loading')
      } else {
        $('.next-btn').removeClass('is-loading')
      }
    },
    /**
     * 登录前执行的业务逻辑
     */
    _onLoginBeforeLogin() {
      Tracker.trackEvent('fin_loan_abroad_register_ck', {
        if_choose_agreement: Index.$data.isChecked ? 1 : 0,
        button_name: 'next',
      })
      Tracker.trackWithMgm(
        'fin_loan_mgm_abroad_register_ck'
      )
      // w2a上报：输入手机号码，格式校验通过"并点击获取验证码（Trigger login action instead)"
      Tracker.trackWithMedia(2004)
      // 输入手机号后点击确定的时间戳
      setStore('smsSendTime', Date.now())
    },
    /**
     * 登录后立即执行的业务逻辑
     */
    _onLoginAfterLogin(user: LoginData) {
      // 输入验证码后点击确定的时间戳
      setStore('smsSubmitTime', Date.now())
      // 挽留弹窗
      import('@/utils/retention-popup')
        .then((module) => module.default.active())
        // 加载失败不报错
        .catch(console.log)
      raven.setConfig({ uid: user.uid })
      Omega.setUserName(user.uid)
      // w2a上报：用户登录（免ocr）
      Tracker.trackWithMedia(2007)
    },
    /**
     * 登录后并获取首页数据后，立即执行的业务逻辑
     */
    _onLoginAfterFetch(user: LoginData, data: any) {
      Index.methods.storeAbState(data)
      // 设置Omega埋点公参
      Tracker.setGlobalData({
        userName: user.uid,
        uid: user.uid,
        pub_uid: user.uid,
        cfrnid: data.cfrnid || data.preCfrnid,
        pub_cfrnid: data.cfrnid || data.preCfrnid,
        credit_status: data.creditDetail?.status,
        pub_credit_status: data.creditDetail?.status,
        audit_status: data.creditDetail?.auditStatus,
        pub_audit_status: data.creditDetail?.auditStatus,
        pub_credit_status_unified:
          data.unifiedKycDetail?.status,
        city_id: data.cityId,
        country: data.canonicalCountryCode,
        country_code: data.canonicalCountryCode,
        loan_status: data.withdrawInfo?.status,
        pub_loan_status: data.withdrawInfo?.status,
        order_status: data.repayInfo?.repayStatus,
        pub_retry_status: data.creditDetail?.retryStatus,
        retry_status: data.creditDetail?.retryStatus,
        white_status: data.whiteInfo?.whiteStatus,
      })
      Tracker.trackEvent(
        'fin_loan_abroad_information_email_bt',
        { whether: data.email ? 1 : 0 }
      )
      // 设置KYC流程接口公参
      setStore('httpHomeIndex', data)
      // 加载静态资源
      $framework.run(() => import('@/main-micro-page'))
      // wsg初始化
      WSG.init()
      // 风控数据上报
      Tracker.dryRun()
      // 展示微应用页面
      $('#root').hide()
      $('#app').show()
      // 内存释放
      setTimeout(() => {
        Index.destroyed()
        $('#root').remove()
      }, 0)
    },
    /**
     * 登录异常处理
     */
    _onLoginCatchError(e: any) {
      Tracker.trackWithRaven('FN:onLogin-wrapper-catch', {
        e: e instanceof Error ? e.toString() : e,
      })
      Tracker.trackEvent(
        'fin_loan_abroad_register_fail_information_bt',
        {
          registererrorcode:
            e instanceof Error
              ? -1
              : e.errno || e.errorCode,
        }
      )
    },
    /**
     * 登录，非UI控件执行
     */
    async onLoginImmediately() {
      // 点击时加载静态资源
      $framework.run()
      Index.methods._onLoginBeforeLogin()
      // 登录检查改成串行
      Login._isLogin().then((data) => {
        if (data.login) {
          Login._after(data as LoginData)
        }
      })
      // 获取外投首页数据
      const { data, errorCode } = await httpHomeIndex()
      if (errorCode !== 10000) {
        throw new Error('Fetch data error')
      }
      // 当接口调用成功时，临时复制ticket，后续覆盖
      setStore('user', {
        ticket: Login.getTicket(),
        uid: data.uid,
        country_calling_code: data.countryCallingCode,
      })
      Index.methods._onLoginAfterLogin(data)
      Index.methods._onLoginAfterFetch(data, data)
    },
    /**
     * UI登录
     */
    async onLogin() {
      // 点击时加载静态资源
      $framework.run()
      // 协议未勾选
      if (!Index.$data.isChecked) {
        Index.methods.toast(
          $i18n.t('Fintech_Credit_optimization_Sufa_QPAG')
        )
        $('.tick_box .gesture').show()
        return
      }
      if (
        // 有处理中的登录请求
        Index.$data.isLoading
      ) {
        return
      }
      Index.methods._onLoginBeforeLogin()
      Index.methods.setLoading(true)
      try {
        /**
         * passport组件，如果用户输入错误的手机号，并不会给任何回调，会锁线程
         * 因此前面加的loading锁，必须在一段时间内解锁，否则用户无法重复提交。
         */
        setTimeout(
          () => Index.methods.setLoading(false),
          5000
        )
        const tel = $('#tel').val()
        // 存储用户数据
        const user = await Login.checkPhone(tel)
        if (Index.$data.init) {
          return
        }
        Index.$data.init = true
        MainLoading.show()
        // 线程解锁后，再加一次loading锁
        Index.methods.setLoading(true)
        Index.methods._onLoginAfterLogin(user)
        // 获取外投首页数据
        const { data, errorCode } = await httpHomeIndex()
        if (errorCode !== 10000 && errorCode !== -1) {
          Tracker.trackEvent(
            'fin_loan_abroad_register_fail_information_bt',
            {
              registererrorcode: errorCode,
            }
          )
          Index.destroyed()
          MainLoading.hide()
          // 渲染新版兜底页
          return $framework.run(
            () => import('@/main-maintenance-page')
          )
        }
        Index.methods._onLoginAfterFetch(user, data)
      } catch (e: any) {
        Index.methods._onLoginCatchError(e)
        MainLoading.hide()
      } finally {
        Index.methods.setLoading(false)
      }
    },
    onBlur() {
      Tracker.trackEvent(
        'fin_loan_abroad_register_phone_typ',
        {
          input_duration:
            Date.now() - (Index.$data.startTime as number),
        }
      )
      // 时长
      Tracker.trackWithCache({
        page: PAGE.register,
        position: POSITION.phone,
      })
      // 次数
      Tracker.trackWithCache({
        page: PAGE.register,
        position: POSITION.phone,
        sw: 1,
      })
      const value = $('#tel').val()
      const [isValid] = Index.methods.validate(value)
      // 最后一次有效数据的时长
      if (isValid) {
        Tracker.trackWithCache({
          page: PAGE.register,
          position: POSITION.phone,
          starttime: Index.$data.startTime,
          endtime: Date.now(),
        })
      }
    },
    onFocus() {
      Index.$data.startTime = Date.now()
    },
    onOpenProtocol(target: HTMLElement) {
      // 次数
      Tracker.trackWithCache({
        page: PAGE.register,
        position: POSITION.protocol,
        sw: 1,
      })
      Tracker.trackEvent('fin_loan_abroad_register_ck', {
        if_choose_agreement: Index.$data.isChecked ? 1 : 0,
        button_name: target.innerText,
      })
    },
    // 控制协议勾选函数
    onToggleChecked(target: HTMLElement) {
      target.classList.toggle('checked')
      Index.$data.isChecked = !Index.$data.isChecked
      // 点击是关闭小手提示，等待点按钮时再检查
      if (!Index.$data.isChecked) {
        $('.tick_box .gesture').hide()
      }
    },
    // 手机号验证
    onValidate() {
      const value = $('#tel').val()
      const [isValid] = Index.methods.validate(value)
      if (isValid) {
        Index.$data.isPassed = true
      } else {
        Index.$data.isPassed = false
      }
    },
    onDelegate() {
      const self = this as unknown as HTMLElement
      const checkResult = onDelegate(self)
      if (checkResult === false) {
        return
      }
      if (checkResult.action === 'login') {
        return Index.methods.onLogin()
      }
      if (checkResult.action === 'protocol') {
        return Index.methods.onToggleChecked(self)
      }
      if (checkResult.action === 'agreement') {
        return Index.methods.onOpenProtocol(self)
      }
    },
    // 协议
    async initProtocol() {
      let html = ''
      try {
        const { data } = await httpList<List>()
        html = $i18n.t(
          'financial_loan_freya_credit_register_pop__2_description',
          {
            agreement_name1: `<a href="${data[0].url}" class="color-101010">${data[0].name}</a>`,
            agreement_name2: `<a href="${data[1].url}" class="color-101010">${data[1].name}</a>`,
          }
        )
      } catch (e: any) {
        Tracker.trackWithRaven('FN:initProtocol', {
          e: e.toString(),
        })
      }
      $('[data-action="agreement"]').html(html)
    },
    toggleRegBoxStylePosition(event: any) {
      if (event.detail === false) {
        $('#js_inner').css({
          bottom: 0,
        })
      }
      if (typeof event.detail === 'number') {
        $('#js_inner').css({
          bottom: event.detail + 'px',
        })
      }
    },
    /**
     * 元素事件绑定 或 解绑
     */
    toggleEvent(fn: 'on' | 'off') {
      const $tel = $('#tel')
      $tel[fn]('blur', Index.methods.onBlur)
      $tel[fn]('focus', Index.methods.onFocus)
      $tel[fn]('input', Index.methods.onValidate)
      $('[data-action]')[fn](
        'click',
        Index.methods.onDelegate
      )
      $(window)[fn](
        'scroll',
        Index.methods.toggleStyleByScroll
      )
      $('#advCookieConsent')[fn](
        'cookieConsentHeight',
        Index.methods.toggleRegBoxStylePosition
      )
      $('#advCookieConsent')[fn](
        'showCookieState',
        Index.methods.toggleRegBoxStylePosition
      )
    },
    /**
     * 人拉人停留时长埋点
     */
    toggleTrack(start = true) {
      if (start) {
        Index.$data.stayTimer = setInterval(
          () =>
            Tracker.trackWithMgm(
              'fin_loan_mgm_abroad_register_2s_time_sw'
            ),
          2000
        )
      } else {
        clearInterval(Index.$data.stayTimer as number)
      }
    },
    toggleStyleByScroll: debounce(() => {
      const $el = $('#js_reg_box')
      if ($el.length === 0) {
        return
      }
      let distance = 500
      try {
        // 滚动正好超过注册模块底部时
        distance = $el.offset().top + 220
      } catch (e: any) {
        Tracker.trackWithRaven('FN:toggleStyleByScroll', {
          e: e.toString(),
        })
      }
      if (window.scrollY > distance) {
        $el.addClass('fixed')
      } else {
        $el.removeClass('fixed')
      }
    }, 15),
  },
  $router: <LiteRouter | null>null,
  data() {
    return {
      stayTimer: 0,
      init: false,
      startTime: 0,
      pageStartTime: +new Date(),
      isLoading: false,
      isPassed: false,
      isChecked: false,
      isToasting: false,
    }
  },
  $data: <Record<string, unknown>>{},
  mounted($router: LiteRouter) {
    // 上报omega
    Tracker.trackEvent('fin_loan_abroad_register_sw')
    Tracker.trackWithMgm(
      'fin_loan_mgm_abroad_register_sw',
      {
        m1_uid: URL.get('uid'), // 上报m1_uid
      }
    )
    Index.$router = $router
    Index.$data = Index.data()
    Index.methods.initProtocol()
    Tracker.trackWithMedia(2001)
    Index.methods.toggleEvent('on')
    Index.methods.onValidate()
    Index.methods.toggleTrack()
    /**
     * 添加样式。
     * 卸载时找不到元素报错不处理
     */
    try {
      $('#js_reg_box').css({
        'min-height':
          $('#js_reg_box').offset().height + 'px',
      })
    } catch (e) {
      console.log(e)
    }
  },
  /**
   * 清理内存
   */
  destroyed() {
    Tracker.trackWithCache({
      page: PAGE.register,
      starttime: this.$data.pageStartTime,
      endtime: +new Date(),
    })
    Index.methods.toggleEvent('off')
    Index.methods.toggleTrack(false)
    this.$data = {}
  },
}
export default Index
